/**
 * SupportContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled support container. Centers its content in the middle of the page.
 */
const SupportContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  text-align: center;
`;

export default withOpacity(SupportContainer);
